import React, { useState } from "react";
import YoutubeTutorial from "Components/common/YoutubeTutorial";
import ConfigureButton from "../ConfigureButton";
import InstallButton from "../InstallButton";

const SalesForceAction = props => {
  const {
    salesforceConnected = "",
    data: { youtubeLink = "" },
    toolTipPopup,
    sfConfigureCbk = () => {},
    isFeatureEnabled = false
  } = props || {};
  const [showVideo, setVideo] = useState(false);

  const closeVideo = () => {
    setVideo(false);
  };

  return !isFeatureEnabled ? (
    <InstallButton {...props} />
  ) : salesforceConnected ? (
    <div className="buttonCont wrapConnectedBtn">
      <div
        className={`connectedBtnCont btn ${isFeatureEnabled ? "" : "disabled"}`}
        onClick={sfConfigureCbk}
      >
        <i className="material-icons-outlined">settings</i>
        Configure
      </div>
      {showVideo && (
        <YoutubeTutorial videoId={youtubeLink} closeCbk={closeVideo} />
      )}
    </div>
  ) : (
    <div className="buttonCont">
      <ConfigureButton
        toolTipPopup={toolTipPopup}
        value={"Configure"}
        configureCbk={sfConfigureCbk}
        isFeatureEnabled={isFeatureEnabled}
      />
    </div>
  );
};

export default SalesForceAction;
export { SalesForceAction };
